<template>
  <div class="modal-wrap" @click.self="close">
    <div class="modal px-4 py-4 px-md-5 py-md-5">
      <div class="modal-close-btn" @click="close">×</div>
      <slot />
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['closeModal']);

function close() {
  emits('closeModal');
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/main.scss';

.modal-wrap {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1051; // above the exchange offers dock (1040/1041)
  background: main.$black-202;
  width: 100%;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.modal {
  position: relative;
  border-radius: 15px;
  background: main.$white_01;
  box-shadow: 0 1px 5px 0 main.$black-100;
  width: 570px;
  overflow-x: auto;
  max-height: calc(100vh - 5rem);
  overflow-y: auto;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    box-shadow: none;
  }
}
.modal-close-btn {
  position: absolute;
  right: 0;
  top: 0;
  padding: 24px;
  line-height: 0px;
  cursor: pointer;
  color: main.$blue-100;
  font-size: 2rem;
  z-index: 10;
  &:hover {
    color: main.$color-primary_01;
  }
  @media screen and (min-width: map.get(main.$grid-breakpoints, sm)) {
    line-height: 1rem;
  }
}
</style>
